"use client";
import React from "react";
import Image from "next/image";
import BookOpenDay from "@packages/shared-components/common-utilities/cards/interaction-button/bookopenday";
import { GA4DataLayer } from "@packages/lib/utlils/helper-function";
import { GAConstants } from "@packages/shared-components/services/constants";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
interface compInterface {
  cardItem: any;
  enquiryProps: any;
  commonGAAttrs: any;
  podInfo: {
    podType: string;
    isClearing?: boolean;
    studyLevel: string;
    contentFulCtaInfo?: any;
  };
  isAdvertiser?: boolean;
  isOnlineOpenDays?: boolean;
  hasVeppleSection?: boolean;
  commonOldGAAttrs: any;
}
const OpenDaysCardComp = ({
  cardItem,
  podInfo,
  enquiryProps,
  commonGAAttrs,
  isAdvertiser,
  isOnlineOpenDays,
  hasVeppleSection,
  commonOldGAAttrs,
}: compInterface) => {
   
  return (
    <>
      <div className="flex">
        {cardItem?.eventDate?.month &&
          cardItem?.eventDate?.date &&
          cardItem?.eventDate?.year && (
            <div
              className={`opd-calendar ${cardItem?.isSponsored ? "bg-blue-100" : "bg-grey-100"} border-r border-grey-200`}
            >
              <div className="flex flex-col items-center p-[16px_18px]">
                <div className="small font-semibold">
                  {cardItem?.eventDate?.month}
                </div>
                <div className="h2 font-bold">{cardItem?.eventDate?.date}</div>
                <div className="small font-semibold">
                  {cardItem?.eventDate?.year}
                </div>
              </div>
            </div>
          )}
        <div className={`card-body flex flex-1 min-w-0 flex-col justify-between gap-[16px] p-[16px] ${
          (() => {
            if (!isAdvertiser) return "h-[230px]";
            const hasWusca = cardItem?.wuscaDetails?.length > 0;
            const hasEventTime = !isOnlineOpenDays && cardItem?.eventTime;
            if (hasWusca && hasEventTime) return "h-[276px]";
            if (hasWusca || hasEventTime) return "h-[246px]";
            return "h-[230px]";
          })()
        }`}>
          <div className="flex flex-col w-full">
            {isAdvertiser && (
              <div className="w-fit text-[12px] leading-[20px] font-bold text-grey-500 bg-grey-100 p-[0_8px_1px] rounded-[4px] z-0 uppercase mb-[8px]">
                {cardItem?.eventType}
              </div>
            )}
            <div className="card-title font-farro para-lg font-bold text-grey300 line-clamp-2">
              {cardItem?.institutionName}
            </div>
            {cardItem?.openDaysType && (
              <div className="card-subtitle small font-semibold line-clamp-1 mt-[8px]">
                {cardItem?.openDaysType}
              </div>
            )}
    
            {cardItem?.wuscaDetails?.length > 0 && (
              <div className="mt-[8px]">
                <div>
                  <div className="para small font-semibold ">
                    WUSCA overall ranking
                  </div>
                  {cardItem?.wuscaDetails?.map(
                    (wuscaItem: any, index: Number) => (
                      <div
                        className="rating-pod flex items-center gap-[8px]"
                        key={"wuscaCpc" + index}
                      >
                        {wuscaItem?.rating && wuscaItem?.rating > 0 && (
                          <div className="rating-card flex items-center gap-[4px]">
                            <Image
                              src="/static/assets/icons/blue-star-icon.svg"
                              width="24"
                              height="24"
                              alt="Rating icon"
                            />
                            <span className="font-normal small text-grey300">
                              {Math.round(wuscaItem?.rating)} / 5
                            </span>
                          </div>
                        )}
                        {wuscaItem?.wuscaRanking && (
                          <span className="block font-normal small text-grey-700">
                            {wuscaItem?.wuscaRanking}
                          </span>
                        )}
                      </div>
                    ),
                  )}
                </div>
              </div>
            )}
            {((!isOnlineOpenDays && cardItem?.campusAddress) || (!isOnlineOpenDays && cardItem?.eventTime)) && (
            <div className="mt-[8px]">
              {!isOnlineOpenDays && cardItem?.campusAddress && (
                <div className="x-small text-grey-900 line-clamp-2 break-words">
                  {cardItem?.campusAddress?.toLowerCase() === "virtual"
                    ? <><span className="font-bold">Tours available:</span> Virtual</>
                    : [cardItem?.campusAddress, cardItem?.postcode].filter(Boolean).join(", ")}
                </div>
              )}
              {!isOnlineOpenDays && cardItem?.eventTime && (
                <div
                  className={`flex items-center gap-[4px] ${cardItem.eventTime === "00:00-00:00" || cardItem.eventTime === "-" ? "hidden" : ""}`}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 3.77778V6L7.66667 7.66667M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
                      stroke="#333333"
                      strokeWidth="1.13"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="xs-small font-semibold text-grey300 truncate">
                    {cardItem?.eventTime}
                  </span>
                </div>
              )}
            </div>
            )}
          </div>
          <div className="flex gap-[8px] w-full flex-col md:flex-row">
            {!(
              cardItem?.eventType?.toLowerCase() === "virtual tour" &&
              !hasVeppleSection &&
              !cardItem?.bookingUrl
            ) && (
              <BookOpenDay
                enquiryProps={{...enquiryProps,eventId:cardItem?.eventId}}
                commonGAAttrs={commonGAAttrs}
                btnName={
                  cardItem?.eventType === "VIRTUAL TOUR" ||
                  cardItem?.eventType === "Virtual Tour"
                    ? "Take virtual tour"
                    : cardItem?.eventType === "VIRTUAL EVENT" ||
                        cardItem?.eventType === "Virtual Event"
                      ? "Book virtual event"
                      : podInfo?.contentFulCtaInfo?.bookOpenDay?.ctaName
                }
                commonOldGAAttrs={commonOldGAAttrs}
                eventType={cardItem?.eventType}
                hasVeppleSection={hasVeppleSection}
                bookingUrl={cardItem?.bookingUrl ||cardItem?.ctaDetails?.ctaUrl }
                institutionTextKey={cardItem?.institutionTextKey}
                institutionId={cardItem?.institutionId}
              />
            )}
          </div>
        </div>
      </div>
      {!isAdvertiser && (
        <div className="flex justify-center items-center w-full p-[16px] border-t border-t-grey-200">
          {cardItem?.courseCount &&
            cardItem?.ctaDetails?.openDayFlag == "Y" && (
              <a
                href={
                  cardItem?.openDaysType?.toLowerCase() === "postgraduate open day"
                    ? `/open-days/${cardItem?.institutionTextKey}/postgraduate/${cardItem?.institutionId}/`
                    : `/open-days/${cardItem?.institutionTextKey}/${cardItem?.institutionId}/`
                }
                className="small font-semibold text-primary-400 text-center block hover:underline"
                onClick={() => {
                  // Show full-page loading skeleton
                  emitter.emit("searchpageloading", true);
                  const bodyContainer = document.getElementById("bodyContainer");
                  const footer = document.getElementById("footerComponent");
                  bodyContainer?.classList?.add("hidden");
                  footer?.classList?.add("hidden");

                  GA4DataLayer({
                    event: GAConstants.track_event,
                    event_name: "redirection_link_click",
                    click_text: "virtual event",
                    field: `${cardItem?.institutionName} ${cardItem?.openDaysType || "open day"}`,
                    institution_id: cardItem?.institutionId,
                    institution_name: cardItem?.institutionTextKey,
                  });
                }}
              >
                View {cardItem?.courseCount} open{" "}
                {cardItem?.courseCount === 1 ? "day" : "days"}
              </a>
            )}
        </div>
      )}
    </>
  );
};

export default OpenDaysCardComp;
